* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
}

.wrapper {
  padding: 2px;
  flex-flow: column;

  gz-text {
    padding: 0 calc(var(--spacer) * 4.2);
  }
}

gz-timeline-item {
  &:last-child {
    --chart-101-pressed-dividers: transparent;
  }
}
